import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import { ContextProvider as MembersContextProvider } from 'components/Managers/Members/Context';
import { ContextProvider } from './Context';
import Main from './Main';

export default function Index({ enterpriseId }) {
  return (
    <StrictMode>
      <UsersContextProvider>
        <ContextProvider enterpriseId={enterpriseId}>
          <MembersContextProvider enterpriseId={enterpriseId}>
            <Main />
          </MembersContextProvider>
        </ContextProvider>
      </UsersContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
